import { render } from "./ShippingFeeConfig.vue?vue&type=template&id=5128aef6&ts=true"
import script from "./ShippingFeeConfig.vue?vue&type=script&lang=ts"
export * from "./ShippingFeeConfig.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__